export * from '@dc-shared-web/hoc/createCitationComponent'
